import DeclineOrganizationInviteSuccessModal from './DeclineOrganizationInviteSuccessModal';

export default DeclineOrganizationInviteSuccessModal;
